if (!customElements.get('announcement-popup')) {
  customElements.define(
    'announcement-popup',
    class AnnouncementPopup extends HTMLElement {
      connectedCallback() {
        this.popup = this.querySelector('[data-announcement-popup]');
        if (!this.popup) return;

        this.dialog = this.popup.querySelector('.announcement-popup__dialog');
        this.storageKey = this.dataset.storageKey;
        this.days = parseInt(this.dataset.days, 10) || 1;
        this.designMode = this.dataset.designMode === 'true';
        this.isMobile = window.matchMedia('(max-width: 749px)').matches;
        this.isOpen = false;
        this.timer = null;
        this.onKeydown = this.onKeydown.bind(this);

        this.popup.querySelectorAll('[data-popup-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
        // Clicking the image link also counts as "seen"
        this.popup.querySelectorAll('[data-popup-link]').forEach((el) => {
          el.addEventListener('click', () => this.remember(this.days));
        });

        this.init();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('keydown', this.onKeydown);
        document.documentElement.classList.remove('announcement-popup-open');
      }

      init() {
        // Theme editor: always show so the design can be previewed.
        if (this.designMode) {
          this.timer = setTimeout(() => this.open(), 400);
          return;
        }

        if (this.isMobile && this.dataset.showMobile === 'false') return;
        if (!this.isMobile && this.dataset.showDesktop === 'false') return;
        if (this.isHidden()) return;

        const mobileDelay = parseInt(this.dataset.delayMobile, 10);
        const delay = this.isMobile && !isNaN(mobileDelay) ? mobileDelay : parseInt(this.dataset.delay, 10) || 0;
        this.timer = setTimeout(() => this.open(), delay * 1000);
      }

      isHidden() {
        try {
          const until = parseInt(localStorage.getItem(this.storageKey), 10);
          return !isNaN(until) && until > Date.now();
        } catch (e) {
          return false;
        }
      }

      remember(days) {
        if (this.designMode) return;
        try {
          localStorage.setItem(this.storageKey, String(Date.now() + days * 86400000));
        } catch (e) {
          /* storage unavailable */
        }
      }

      open() {
        if (this.isOpen) return;
        this.isOpen = true;
        this.previousFocus = document.activeElement;
        this.popup.classList.add('is-open');
        this.popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('announcement-popup-open');
        document.addEventListener('keydown', this.onKeydown);
        setTimeout(() => {
          const closeBtn = this.popup.querySelector('.announcement-popup__close');
          (closeBtn || this.dialog).focus({ preventScroll: true });
        }, 60);
      }

      close() {
        if (!this.isOpen) return;
        this.isOpen = false;
        this.popup.classList.remove('is-open');
        this.popup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('announcement-popup-open');
        document.removeEventListener('keydown', this.onKeydown);
        this.remember(this.days);
        if (this.previousFocus && this.previousFocus.focus) this.previousFocus.focus({ preventScroll: true });
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          this.close();
          return;
        }
        if (event.key !== 'Tab') return;

        const focusable = Array.from(this.popup.querySelectorAll('button, a[href]')).filter(
          (el) => !el.disabled && el.offsetParent !== null
        );
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }
  );
}
